module.exports = __webpack_public_path__ + "static/gf-us-e57fa8b2f44a67237a71ae2ff678569b.jpg";